export const CV = {
    hero: {
      firstname: "Alfonso",
      name: "Cifuentes Alonso",
      city: "Coslada / Madrid",
      email: "alfonsocifuentes83@gmail.com",
      birthDate: "14/06/1983",
      phone: "(+34) 697526204",
      image: "https://avatars.githubusercontent.com/u/76941618?v=4",
      gitHub: "https://github.com/AlfonsoCifuentes",
      artStation:"https://www.artstation.com/alfonsocifuentes",
      soundCloud:"https://soundcloud.com/alfonsocifuentes",
      linkedIn:"https://www.linkedin.com/in/alfonso-cifuentes-alonso-13b186b3/",
      aboutMe: [
        {
          info: "💻 Desarrollador web Full Stack apasionado por la tecnología",
        },
        {
          info: "🎚🎛🎚 Técnico de sonido experimentado, productor de música electrónica, DJ y cantante",
        },
        {
          info: "♟ Modelador 3D low y high-poly enfocado a videojuegos",
        },
        {
          info: "👾 Amante de los videojuegos, 😽las mascotas, 🎸gran aficionado a la música",
        },
      ],
    },
    education: [
      {
        name: "Full Stack Web Developer",
        date: "2022",
        where: "Upgrade Hub - Madrid",
        info:"Bootcamp de Full Stack Web Developer",
        skills: "HTML5, CSS, JavaScript, Node, Angular, React, MongoDb, SQL, PHP, Git, SCRUM"
      },
      {
        name: "Máster en modelado 3D para videojuegos",
        date: "2017",
        where: "Escuela Trazos - Madrid",
        info:"Máster de 300 horas en modelado 3D para videojuegos, siguiendo el proceso completo y con diversas herramientas",
        skills:"3D Studio Max, Zbrush, Unity, Unreal Engine, Substance Painter",
      },
      {
        name: "Ténico superior en producción de audiovisuales, radio y espectáculos",
        date: "2014",
        where: "I.E.S. Puerta Bonita - Madrid",
        info:"Módulo de FP de grado superior en producción de diversas disciplinas diferentes del mundo audiovisual",
        skills:"Producción de cine, series, teatro, programas, noticiarios y radio. Medios técnicos. Documentación y procedimientos necesarios"
      },
      {
        name: "Técnico superior de sonido",
        date: "2006",
        where: "Escuela CES - Madrid",
        info:"Módulo de FP de grado superior en sonido: grabación, edición, postproducción, directo, mezcla, etc.",
        skills:"Sistemas y medios técnicos, sonido en producciones audiovisuales, mesas de mezclas analógicas y digitales, microfonía y toma microfónica, MIDI, ProTools, Cubase, Ableton Live, manejo de VST..."
      },
    ],
    experience: [
      {
        name: "Técnico de sonido / Locutor / Modelador 3D",
        date: "Actualmente",
        where: "Smile and Learn Digital Creations",
        description:"Locución, grabación y edición de diálogos. Creación de músicas y efectos de sonido. Sonorización para conferencias en SIMO educación. Modelado de entornos 3D, retopología, desarrollo de modelos high/low poly, iluminación, animación, partículas utilizando Zbrush, 3D Studio MAX y Substance Painter. Motores: Unity y Unreal.",
      },
      {
        name: "Profesor en Colegio Oficial de Ingenieros Técnicos de Telecomunicaciones",
        date: "2016",
        where: "C.O.I.T.T.",
        description:
          "Creador y tutor del curso on-line “Grabación y Edición de Audiovisuales” impartido por el Colegio Oficial de Ingenieros Técnicos (COITT)",
      },
      {
        name: "Editor de vídeo/diseñador gráfico/técnico de sonido",
        date: "2016",
        where: "Enixma Digital",
        description:"Grabación de profesores impartiendo cursos on-line para después realizar su posterior procesado de imagen y sonido con las tareas relacionadas que esto conlleva. Edición de vídeo en Sony Vegas, Premiere y Adobe After Effects, creación de músicas y efectos en Ableton Live y Cubase.",
      },
      {
        name: "Helpdesk & Community Manager",
        date: "2012",
        where: "Stock UNO",
        description:"Asistencia Técnica de Sony PlayStation y Soporte Técnico, resolviendo incidencias y haciendo seguimiento de ellas, consultas juegos online, puertos, configuraciones de red, etc. Administrador del foro oficial de ayuda y asistencia técnica de Play Station.",
      },
      {
        name: "Beta Tester",
        date: "2010",
        where: "DL Multimedia",
        description:"Language tester en diversos videojuegos de diversas plataformas, mayoritariamente PlayStation 2 y PC",
      },
      {
        name: "Técnico de Sonido",
        date: "2009",
        where: "DL Multimedia",
        description:"Técnico de sonido y responsable de grabación. Empresa dedicada al doblaje de videojuegos. Grabación, edición y postproducción.",
      },
    ],
    languages: [
      {
      language: "Español",
      wrlevel: "Nativo",
      splevel: "Nativo",
      },
      {
        language: "Inglés",
        wrlevel: "Muy alto",
        splevel: "Alto",
        },
  ],
    
    
    habilities: [
      "Buenas prácticas",
      "BEM (Block Element Modifier)",
      "Metodología SCRUM",
      "JIRA",
      "Trello",
      "Habilidades sociales",
      "Carnet de conducir y coche propio",
      "Capacidad de trabajar bajo presión",
      "Buena adaptación a flujos de trabajo",
      "Trabajo en equipo",
      "Capacidad de liderazgo"
    ],

  };